var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import { Component, Emit, Prop } from "vue-property-decorator";
import Add from "../Add.vue";
var BillTable = (function (_super) {
    __extends(BillTable, _super);
    function BillTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = document.documentElement.clientHeight - 280;
        return _this;
    }
    BillTable.prototype.selectionChange = function () { };
    BillTable.prototype.toEdit = function (row) {
        this.$emit("add-tab", {
            component: Add,
            title: "编辑对账单",
            showExist: true,
            name: "edit-upper-sup-check" + row.order_id,
            opener: this,
            cprops: {
                handleType: "edit",
                detail: __assign({}, row)
            }
        });
    };
    BillTable.prototype.toDetail = function (row) {
        this.$emit("to-detail", row);
    };
    __decorate([
        Prop({
            required: true,
            type: Array
        })
    ], BillTable.prototype, "data", void 0);
    __decorate([
        Emit("selection-change")
    ], BillTable.prototype, "selectionChange", null);
    BillTable = __decorate([
        Component
    ], BillTable);
    return BillTable;
}(Vue));
export default BillTable;
